import { render, staticRenderFns } from "./15cbform.vue?vue&type=template&id=94d90756"
import script from "./15cbform.vue?vue&type=script&lang=js"
export * from "./15cbform.vue?vue&type=script&lang=js"
import style0 from "./15cbform.vue?vue&type=style&index=0&id=94d90756&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports